var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_1597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9657 1.57422L28.9662 1.57422C29.5584 1.57361 30.1284 1.81169 30.5505 2.23883L30.9061 1.88738L30.5505 2.23883C30.9727 2.66609 31.2123 3.24769 31.2142 3.8565C31.2142 3.85671 31.2142 3.85691 31.2142 3.85712L31.2142 20.6335C31.2142 21.8962 30.1997 22.915 28.9657 22.915H21.2583C20.2288 22.915 19.2209 23.2098 18.3538 23.7647L13.8708 26.6334C12.8887 27.2619 11.5999 26.5566 11.5999 25.3905C11.5999 24.0233 10.4916 22.915 9.12437 22.915H6.97709C5.74307 22.915 4.72852 21.8962 4.72852 20.6335V3.85564C4.72852 2.59294 5.74307 1.57422 6.97709 1.57422L28.9657 1.57422ZM19.3236 16.9335C20.3709 16.9335 21.2199 16.0845 21.2199 15.0372C21.2199 13.9899 20.3709 13.1409 19.3236 13.1409H12.4962C11.4489 13.1409 10.5999 13.9899 10.5999 15.0372C10.5999 16.0845 11.4489 16.9335 12.4962 16.9335H19.3236ZM23.4465 11.3483C24.4938 11.3483 25.3428 10.4993 25.3428 9.452C25.3428 8.4047 24.4938 7.5557 23.4465 7.5557H12.4962C11.4489 7.5557 10.5999 8.4047 10.5999 9.452C10.5999 10.4993 11.4489 11.3483 12.4962 11.3483H23.4465Z",
    fill: "#FFEA32",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a9b4c35d2027b45a95b99581dd8a45f4.svg";
export { ForwardRef as ReactComponent };